import { useTranslation } from 'react-i18next'
import { Button, DialogContent, DialogActions } from '@material-ui/core'
import useStyles from './styles'

const IframeModal = ({ handleClose, data: { contentUrl, title, withModalActions } }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <DialogContent className={classes.dialogContent}>
        <iframe src={t(contentUrl)} title={t(title)} className={classes.iframe} frameborder="0" />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {withModalActions && (
          <Button color="secondary" variant="contained" onClick={handleClose}>
            {t('common.close')}
          </Button>
        )}
      </DialogActions>
    </>
  )
}

export default IframeModal
